import type { PreviewDetails } from "../content/preview-details.types";
import {
  coworldPlayerTypes,
  type PlayerType,
} from "@/lib/coworld-player-types";
import { recordOf, safeManifestUrl } from "./manifest-record";
export type CoworldSource = {
  sourceUrl: string | null;
  repo: string | null;
  repoUrl: string | null;
  playerTypes: PlayerType[] | null;
};
export function coworldSourceFrom(manifest: unknown): CoworldSource {
  const game = recordOf(recordOf(manifest).game);
  const sourceUrl = safeManifestUrl(recordOf(game.runnable).source_url);
  const m = sourceUrl
    ? /^https:\/\/github\.com\/([^/]+)\/([^/#?]+)/.exec(sourceUrl)
    : null;
  return {
    sourceUrl,
    repo: m ? `${m[1]}/${m[2]}` : null,
    repoUrl: m ? `https://github.com/${m[1]}/${m[2]}` : null,
    playerTypes: coworldPlayerTypes(manifest),
  };
}
function githubOrgOf(url: string | null): string | null {
  const m = url ? /^https:\/\/github\.com\/([^/]+)\//.exec(url) : null;
  return m?.[1] ?? null;
}
export function developerFrom(manifest: unknown): PreviewDetails["developer"] {
  const game = recordOf(recordOf(manifest).game);
  const source = recordOf(game.runnable).source_url;
  const sourceUrl = typeof source === "string" ? source : null;
  const readme = recordOf(recordOf(game.docs).readme);
  const readmeUrl =
    readme.type === "uri" && typeof readme.value === "string"
      ? readme.value
      : null;
  const org = githubOrgOf(sourceUrl) ?? githubOrgOf(readmeUrl);

  if (org) return { name: org, href: `https://github.com/${org}` };

  const owner = typeof game.owner === "string" ? game.owner : null;
  return owner && owner.endsWith("@softmax.com")
    ? { name: "Softmax", href: null }
    : null;
}
